
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState, useEffect } from 'react';

export default function AddTitulareForm() {
  const [formData, setFormData] = useState({
    id: '',
    cementerioId: '1',
    terceroId: '',
    fecha: '',
    observaciones: '-',
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [terceros, setTerceros] = useState([]);
  const [searchTercero, setSearchTercero] = useState('');
  const navigate = useNavigate();

  // Fetch de la lista de terceros al cargar el formulario
  useEffect(() => {
    const fetchTerceros = async () => {
      try {
        const response = await axios.get('/terceros');
        setTerceros(response.data);
      } catch (err) {
        console.error('Error fetching terceros:', err);
      }
    };
    fetchTerceros();
  }, []);

  const filteredTerceros = terceros.filter(
    (tercero) =>
      tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase()) ||
      tercero.documento.toString().includes(searchTercero)
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const handleTerceroSelect = (e) => {
    const selectedTercero = terceros.find(
      (tercero) => tercero.documento.toString() === e.target.value
    );
    
    setFormData({ ...formData, terceroId: e.target.value });
    setSearchTercero(selectedTercero ? `${selectedTercero.documento}` : '');
  };
  

  /*
  const handleTerceroSelect = (e) => {
    setFormData({ ...formData, terceroId: e.target.value });
  };
*/

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = {};
    if (!formData.id) validationErrors.id = 'El campo ID es obligatorio.';
    if (!formData.cementerioId) validationErrors.cementerioId = 'El campo Cementerio ID es obligatorio.';
    if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
    if (!formData.fecha) validationErrors.fecha = 'El campo Fecha es obligatorio.';

    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      try {
        await axios.post(`/titulares/${formData.id}`, {
          cementerioId: parseInt(formData.cementerioId, 10),
          terceroId: formData.terceroId,
          fecha: formData.fecha,
          observaciones: formData.observaciones || '',
        });
        navigate('/home/titulares');
      } catch (err) {
        console.error('Error saving titular:', err);
        setErrors({ submit: 'Error al guardar el titular. Por favor, intente de nuevo.' });
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">Añadir Nuevo Titular</h2>
      <div className="bg-blue-100 shadow-lg rounded-lg p-8 max-w-3xl mx-auto">
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="id">
              ID Sepultura
            </label>
            <input
              type="text"
              name="id"
              value={formData.id}
              onChange={handleChange}
              className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.id ? 'border-red-500' : ''}`}
              placeholder="Ingrese el ID"
            />
            {errors.id && <p className="text-red-500 text-xs italic">{errors.id}</p>}
          </div>
          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="cementerioId">
              Cementerio ID
            </label>
            <input
              type="text"
              name="cementerioId"
              value={formData.cementerioId}
              onChange={handleChange}
              className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.cementerioId ? 'border-red-500' : ''}`}
              placeholder="Ingrese el Cementerio ID"
            />
            {errors.cementerioId && <p className="text-red-500 text-xs italic">{errors.cementerioId}</p>}
          </div>

  <div className="md:col-span-2">
  <label className="block text-gray-700 text-sm font-bold mb-2">Buscar por Tercero</label>
  <input
    type="text"
    placeholder="Buscar por nombre o documento"
    className="border p-2 rounded w-full mb-2"
    value={searchTercero}
    onChange={(e) => setSearchTercero(e.target.value)}
  />
  <select
    value={formData.terceroId}
    onChange={handleTerceroSelect}
    className="border p-2 rounded w-full"
  >
    <option value="">Seleccione un tercero</option>
    {filteredTerceros.map((tercero) => (
      <option key={tercero.documento} value={tercero.documento}>
        {tercero.nombre} - {tercero.documento}
      </option>
    ))}
  </select>
  {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
</div>

        

          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="fecha">
              Fecha
            </label>
            <input
              type="date"
              name="fecha"
              value={formData.fecha}
              onChange={handleChange}
              className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.fecha ? 'border-red-500' : ''}`}
            />
            {errors.fecha && <p className="text-red-500 text-xs italic">{errors.fecha}</p>}
          </div>
          <div className="md:col-span-2">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="observaciones">
              Observaciones
            </label>
            <textarea
              name="observaciones"
              value={formData.observaciones}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              placeholder="Ingrese observaciones"
            />
          </div>
          <div className="md:col-span-2 flex justify-center">
            <button
              type="submit"
              className="bg-blue-600 hover:bg-blue-800 text-white font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline transition duration-300"
              disabled={isLoading}
            >
              {isLoading ? 'Guardando...' : 'Guardar Titular'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}


/*
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState, useEffect } from 'react';

export default function AddTitulareForm() {
  const [formData, setFormData] = useState({
    id: '',
    cementerioId: '1',
    terceroId: '',
    fecha: '',
    observaciones: '-',
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [terceros, setTerceros] = useState([]);
  const [searchTercero, setSearchTercero] = useState('');
  const navigate = useNavigate();

  // Fetch de la lista de terceros al cargar el formulario
  useEffect(() => {
    const fetchTerceros = async () => {
      try {
        const response = await axios.get('/terceros');
        setTerceros(response.data);
      } catch (err) {
        console.error('Error fetching terceros:', err);
      }
    };
    fetchTerceros();
  }, []);

  const filteredTerceros = terceros.filter(
    (tercero) =>
      tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase()) ||
      tercero.documento.toString().includes(searchTercero)
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const handleTerceroSelect = (e) => {
    const selectedTercero = terceros.find(
      (tercero) => tercero.documento.toString() === e.target.value
    );
    
    setFormData({ ...formData, terceroId: e.target.value });
    setSearchTercero(selectedTercero ? `${selectedTercero.documento}` : '');
  };
  

  

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = {};
    if (!formData.id) validationErrors.id = 'El campo ID es obligatorio.';
    if (!formData.cementerioId) validationErrors.cementerioId = 'El campo Cementerio ID es obligatorio.';
    if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
    if (!formData.fecha) validationErrors.fecha = 'El campo Fecha es obligatorio.';

    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      try {
        await axios.post(`/titulares/${formData.id}`, {
          cementerioId: parseInt(formData.cementerioId, 10),
          terceroId: formData.terceroId,
          fecha: formData.fecha,
          observaciones: formData.observaciones || '',
        });
        navigate('/home/titulares');
      } catch (err) {
        console.error('Error saving titular:', err);
        setErrors({ submit: 'Error al guardar el titular. Por favor, intente de nuevo.' });
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">Añadir Nuevo Titular</h2>
      <div className="bg-blue-100 shadow-lg rounded-lg p-8 max-w-3xl mx-auto">
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="id">
              ID Sepultura
            </label>
            <input
              type="text"
              name="id"
              value={formData.id}
              onChange={handleChange}
              className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.id ? 'border-red-500' : ''}`}
              placeholder="Ingrese el ID"
            />
            {errors.id && <p className="text-red-500 text-xs italic">{errors.id}</p>}
          </div>
          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="cementerioId">
              Cementerio ID
            </label>
            <input
              type="text"
              name="cementerioId"
              value={formData.cementerioId}
              onChange={handleChange}
              className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.cementerioId ? 'border-red-500' : ''}`}
              placeholder="Ingrese el Cementerio ID"
            />
            {errors.cementerioId && <p className="text-red-500 text-xs italic">{errors.cementerioId}</p>}
          </div>

  <div className="md:col-span-2">
  <label className="block text-gray-700 text-sm font-bold mb-2">Buscar por Tercero</label>
  <input
    type="text"
    placeholder="Buscar por nombre o documento"
    className="border p-2 rounded w-full mb-2"
    value={searchTercero}
    onChange={(e) => setSearchTercero(e.target.value)}
  />
  <select
    value={formData.terceroId}
    onChange={handleTerceroSelect}
    className="border p-2 rounded w-full"
  >
    <option value="">Seleccione un tercero</option>
    {filteredTerceros.map((tercero) => (
      <option key={tercero.documento} value={tercero.documento}>
        {tercero.nombre} - {tercero.documento}
      </option>
    ))}
  </select>
  {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
</div>
      

          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="fecha">
              Fecha
            </label>
            <input
              type="date"
              name="fecha"
              value={formData.fecha}
              onChange={handleChange}
              className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.fecha ? 'border-red-500' : ''}`}
            />
            {errors.fecha && <p className="text-red-500 text-xs italic">{errors.fecha}</p>}
          </div>
          <div className="md:col-span-2">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="observaciones">
              Observaciones
            </label>
            <textarea
              name="observaciones"
              value={formData.observaciones}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              placeholder="Ingrese observaciones"
            />
          </div>
          <div className="md:col-span-2 flex justify-center">
            <button
              type="submit"
              className="bg-blue-600 hover:bg-blue-800 text-white font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline transition duration-300"
              disabled={isLoading}
            >
              {isLoading ? 'Guardando...' : 'Guardar Titular'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
*/

/*
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState, useEffect } from 'react';

export default function AddTitulareForm() {
  const [formData, setFormData] = useState({
    id: '',
    cementerioId: '1',
    terceroId: '',
    fecha: '',
    observaciones: '-',
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [terceros, setTerceros] = useState([]);
  const [searchTercero, setSearchTercero] = useState('');
  const navigate = useNavigate();

  // Fetch de la lista de terceros al cargar el formulario
  useEffect(() => {
    const fetchTerceros = async () => {
      try {
        const response = await axios.get('/terceros');
        setTerceros(response.data);
      } catch (err) {
        console.error('Error fetching terceros:', err);
      }
    };
    fetchTerceros();
  }, []);

  const filteredTerceros = terceros.filter(
    (tercero) =>
      tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase()) ||
      tercero.documento.toString().includes(searchTercero)
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const handleTerceroSelect = (e) => {
    setFormData({ ...formData, terceroId: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = {};
    if (!formData.id) validationErrors.id = 'El campo ID es obligatorio.';
    if (!formData.cementerioId) validationErrors.cementerioId = 'El campo Cementerio ID es obligatorio.';
    if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
    if (!formData.fecha) validationErrors.fecha = 'El campo Fecha es obligatorio.';

    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      try {
        await axios.post(`/titulares/${formData.id}`, {
          cementerioId: parseInt(formData.cementerioId, 10),
          terceroId: formData.terceroId,
          fecha: formData.fecha,
          observaciones: formData.observaciones || '',
        });
        navigate('/home/titulares');
      } catch (err) {
        console.error('Error saving titular:', err);
        setErrors({ submit: 'Error al guardar el titular. Por favor, intente de nuevo.' });
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">Añadir Nuevo Titular</h2>
      <div className="bg-blue-100 shadow-lg rounded-lg p-8 max-w-3xl mx-auto">
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="id">
              ID Sepultura
            </label>
            <input
              type="text"
              name="id"
              value={formData.id}
              onChange={handleChange}
              className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.id ? 'border-red-500' : ''}`}
              placeholder="Ingrese el ID"
            />
            {errors.id && <p className="text-red-500 text-xs italic">{errors.id}</p>}
          </div>
          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="cementerioId">
              Cementerio ID
            </label>
            <input
              type="text"
              name="cementerioId"
              value={formData.cementerioId}
              onChange={handleChange}
              className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.cementerioId ? 'border-red-500' : ''}`}
              placeholder="Ingrese el Cementerio ID"
            />
            {errors.cementerioId && <p className="text-red-500 text-xs italic">{errors.cementerioId}</p>}
          </div>

        
          <div className="md:col-span-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">Buscar por Tercero</label>
            <input
              type="text"
              placeholder="Buscar por nombre o documento"
              className="border p-2 rounded w-full mb-2"
              value={searchTercero}
              onChange={(e) => setSearchTercero(e.target.value)}
            />
            <select
              value={formData.terceroId}
              onChange={handleTerceroSelect}
              className="border p-2 rounded w-full"
            >
              <option value="">Seleccione un tercero</option>
              {filteredTerceros.map((tercero) => (
                <option key={tercero.documento} value={tercero.documento}>
                  {tercero.nombre} - {tercero.documento}
                </option>
              ))}
            </select>
            {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
          </div>

          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="fecha">
              Fecha
            </label>
            <input
              type="date"
              name="fecha"
              value={formData.fecha}
              onChange={handleChange}
              className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.fecha ? 'border-red-500' : ''}`}
            />
            {errors.fecha && <p className="text-red-500 text-xs italic">{errors.fecha}</p>}
          </div>
          <div className="md:col-span-2">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="observaciones">
              Observaciones
            </label>
            <textarea
              name="observaciones"
              value={formData.observaciones}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              placeholder="Ingrese observaciones"
            />
          </div>
          <div className="md:col-span-2 flex justify-center">
            <button
              type="submit"
              className="bg-blue-600 hover:bg-blue-800 text-white font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline transition duration-300"
              disabled={isLoading}
            >
              {isLoading ? 'Guardando...' : 'Guardar Titular'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
*/

/* CORRECTO
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddTitulareForm() {
    const [formData, setFormData] = useState({
        id: '',
        cementerioId: '1',
        terceroId: '',
        fecha: '',
        observaciones: '-'
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const validationErrors = {};
        if (!formData.id) validationErrors.id = 'El campo ID es obligatorio.';
        if (!formData.cementerioId) validationErrors.cementerioId = 'El campo Cementerio ID es obligatorio.';
        if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
        if (!formData.fecha) validationErrors.fecha = 'El campo Fecha es obligatorio.';

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.post(`/titulares/${formData.id}`, {
                    cementerioId: parseInt(formData.cementerioId, 10),
                    terceroId: formData.terceroId,
                    fecha: formData.fecha,
                    observaciones: formData.observaciones || ''
                });
                navigate('/home/titulares');
            } catch (err) {
                console.error('Error saving titular:', err);
                setErrors({ submit: 'Error al guardar el titular. Por favor, intente de nuevo.' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">Añadir Nuevo Titular</h2>
            <div className="bg-blue-100 shadow-lg rounded-lg p-8 max-w-3xl mx-auto">
                <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="id">
                            ID sepultura
                        </label>
                        <input
                            type="text"
                            name="id"
                            value={formData.id}
                            onChange={handleChange}
                            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.id ? 'border-red-500' : ''}`}
                            placeholder="Ingrese el ID"
                        />
                        {errors.id && <p className="text-red-500 text-xs italic">{errors.id}</p>}
                    </div>
                   
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="cementerioId">
                            Cementerio ID
                        </label>
                        <input
                            type="text"
                            name="cementerioId"
                            value={formData.cementerioId}
                            onChange={handleChange}
                            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.cementerioId ? 'border-red-500' : ''}`}
                            placeholder="Ingrese el Cementerio ID"
                        />
                        {errors.cementerioId && <p className="text-red-500 text-xs italic">{errors.cementerioId}</p>}
                    </div>
                  
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="terceroId">
                            Tercero ID
                        </label>
                        <input
                            type="text"
                            name="terceroId"
                            value={formData.terceroId}
                            onChange={handleChange}
                            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.terceroId ? 'border-red-500' : ''}`}
                            placeholder="Ingrese el Tercero ID"
                        />
                        {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
                    </div>
                   
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="fecha">
                            Fecha
                        </label>
                        <input
                            type="date"
                            name="fecha"
                            value={formData.fecha}
                            onChange={handleChange}
                            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.fecha ? 'border-red-500' : ''}`}
                        />
                        {errors.fecha && <p className="text-red-500 text-xs italic">{errors.fecha}</p>}
                    </div>
                   
                    <div className="md:col-span-2">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="observaciones">
                            Observaciones
                        </label>
                        <textarea
                            name="observaciones"
                            value={formData.observaciones}
                            onChange={handleChange}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            placeholder="Ingrese observaciones"
                        />
                    </div>
                    
                    <div className="md:col-span-2 flex justify-center">
                        <button
                            type="submit"
                            className="bg-blue-600 hover:bg-blue-800 text-white font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline transition duration-300"
                            disabled={isLoading}
                        >
                            {isLoading ? 'Guardando...' : 'Guardar Titular'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
*/

/*
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddTitulareForm() {
    const [formData, setFormData] = useState({
        id: '',
        cementerioId: '',
        terceroId: '',
        fecha: '',
        observaciones: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validación básica
        const validationErrors = {};
        if (!formData.id) validationErrors.id = 'El campo ID es obligatorio.';
        if (!formData.cementerioId) validationErrors.cementerioId = 'El campo Cementerio ID es obligatorio.';
        if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
        if (!formData.fecha) validationErrors.fecha = 'El campo Fecha es obligatorio.';

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.post(`/titulares/${formData.id}`, {
                    cementerioId: parseInt(formData.cementerioId, 10),
                    terceroId: formData.terceroId,
                    fecha: formData.fecha,
                    observaciones: formData.observaciones || ''
                });
                navigate('/home/titulares');
            } catch (err) {
                console.error('Error saving titular:', err);
                setErrors({ submit: 'Error al guardar el titular. Por favor, intente de nuevo.' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6">Añadir Nuevo Titular</h2>
            <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
                
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="id">
                        ID
                    </label>
                    <input
                        type="text"
                        name="id"
                        value={formData.id}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.id ? 'border-red-500' : ''}`}
                        placeholder="Ingrese el ID"
                    />
                    {errors.id && <p className="text-red-500 text-xs italic">{errors.id}</p>}
                </div>
                
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="cementerioId">
                        Cementerio ID
                    </label>
                    <input
                        type="text"
                        name="cementerioId"
                        value={formData.cementerioId}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.cementerioId ? 'border-red-500' : ''}`}
                        placeholder="Ingrese el Cementerio ID"
                    />
                    {errors.cementerioId && <p className="text-red-500 text-xs italic">{errors.cementerioId}</p>}
                </div>
            
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="terceroId">
                        Tercero ID
                    </label>
                    <input
                        type="text"
                        name="terceroId"
                        value={formData.terceroId}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.terceroId ? 'border-red-500' : ''}`}
                        placeholder="Ingrese el Tercero ID"
                    />
                    {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
                </div>
                
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="fecha">
                        Fecha
                    </label>
                    <input
                        type="date"
                        name="fecha"
                        value={formData.fecha}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.fecha ? 'border-red-500' : ''}`}
                    />
                    {errors.fecha && <p className="text-red-500 text-xs italic">{errors.fecha}</p>}
                </div>
            
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="observaciones">
                        Observaciones
                    </label>
                    <textarea
                        name="observaciones"
                        value={formData.observaciones}
                        onChange={handleChange}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        placeholder="Ingrese observaciones"
                    />
                </div>
                
                <div className="flex items-center justify-between">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Titular'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/